import PasswordSchema from 'password-validator'
import React, { Component } from 'react'
import styled from 'styled-components'
import Row from '../components/Row'

const Colored = styled.div`
  text-align: center;
  color: var(--${props => props.good ? 'green' : 'gray'});
`

const Icon = styled.i`
  margin-right: 0.5rem;
`

const lengthCheck = new PasswordSchema()
lengthCheck.is().min(8)

const uppercaseCheck = new PasswordSchema()
uppercaseCheck.has().uppercase()

const lowercaseCheck = new PasswordSchema()
lowercaseCheck.has().lowercase()

const digitsCheck = new PasswordSchema()
digitsCheck.has().digits()

const symbolsCheck = new PasswordSchema()
symbolsCheck.has().symbols()

export default class PasswordCheck extends Component {
  render() {
    const { password } = this.props
    const length = lengthCheck.validate(password)
    const lengthIcon = length ? 'fas fa-check' : 'fas fa-times'
    const uppercase = uppercaseCheck.validate(password)
    const uppercaseIcon = uppercase ? 'fas fa-check' : 'fas fa-times'
    const lowercase = lowercaseCheck.validate(password)
    const lowercaseIcon = lowercase ? 'fas fa-check' : 'fas fa-times'
    const digits = digitsCheck.validate(password)
    const digitsIcon = digits ? 'fas fa-check' : 'fas fa-times'
    const symbols = symbolsCheck.validate(password)
    const symbolsIcon = symbols ? 'fas fa-check' : 'fas fa-times'

    return (
      <Row>
        <Row.Cell>
          <Colored good={length}>
            <Icon className={lengthIcon} />
            8&nbsp;chars.
          </Colored>
        </Row.Cell>
        <Row.Cell>
          <Colored good={uppercase}>
            <Icon className={uppercaseIcon} />
            ABC
          </Colored>
        </Row.Cell>
        <Row.Cell>
          <Colored good={lowercase}>
            <Icon className={lowercaseIcon} />
            abc
          </Colored>
        </Row.Cell>
        <Row.Cell>
          <Colored good={digits}>
            <Icon className={digitsIcon} />
            123
          </Colored>
        </Row.Cell>
        <Row.Cell>
          <Colored good={symbols}>
            <Icon className={symbolsIcon} />
            !@#
          </Colored>
        </Row.Cell>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PasswordCheck.js